import React from "react";
import { Button, TextField, InputLabel, Select, MenuItem } from "@material-ui/core";
import FormControl from '@material-ui/core/FormControl';
import AddBoxIcon from '@material-ui/icons/AddBox';
import CloseIcon from '@material-ui/icons/Close';
import './AddNewGroupClassWindow.css';
import { hasBossAccess } from '../../utils/permissions';

export interface IAddNewGroupClassWindowProps {
    language: string,
    dateShowing: string,
    classroomList: any,
    genreTypeLists: any,
    ageGroupLists: any,
    openingHourList: any,
    tutorInfos: any,
    occupancyOfTheDay: any,
    newClassStartingTime: string | null,
    newClassStartingTimeList: any[],
    newClassDurationList: any[],
    newClassDuration: string | null,
    newClassRoomInput: string | null,
    newClassGenre: string | null,
    newClassAgeGroup: string | null,
    newClassCapacity: number | null,
    newClassTutorList: any[] | null,
    newClassTutor: string | null,
    newClassFullyOccupying: boolean,
    showRepeatSettings: boolean,
    isRepeating: boolean,
    repeatEndDate: string | null,
    handleClose: () => void,
    handleSubmit: () => void,
    handleRoomInput: (event: any) => void,
    handleStringTimeInput: (event: any) => void,
    handleDurationInput: (event: any) => void,
    handleGenreInput: (event: any) => void,
    handleAgeGroupInput: (event: any) => void,
    handleTutorInput: (event: any) => void,
    handleCapacityInput: (event: any) => void,
    handleFullyOccupyingToggle: () => void,
    handleRepeatToggle: () => void,
    handleRepeatEndTypeChange: (type: 'date' | 'forever') => void,
    handleRepeatEndDateChange: (event: any) => void,
    tokenPayload: any
}

class AddNewGroupClassWindow extends React.Component<IAddNewGroupClassWindowProps> {
    render() {
                        const {
            language,
            dateShowing,
            classroomList,
            genreTypeLists,
            ageGroupLists,
            newClassStartingTimeList,
            newClassDurationList,
            newClassStartingTime,
            newClassDuration,
            newClassRoomInput,
            newClassGenre,
            newClassAgeGroup,
            newClassCapacity,
            newClassTutorList,
            newClassTutor,
            newClassFullyOccupying,
            showRepeatSettings,
            isRepeating,
            repeatEndDate,
            handleClose,
            handleSubmit,
            handleRoomInput,
            handleStringTimeInput,
            handleDurationInput,
            handleGenreInput,
            handleAgeGroupInput,
            handleTutorInput,
            handleCapacityInput,
            handleFullyOccupyingToggle,
            handleRepeatToggle,
            handleRepeatEndTypeChange,
            handleRepeatEndDateChange,
            tokenPayload
        } = this.props;

        return (
            <div className="addNewGroupClassOverlay">
                <div className="addNewGroupClassWindow">
                    <div className="windowHeader">
                        <div className="windowTitle">
                            {language !== "eng" ? "新增一般課堂" : "Add New Group Class"}
                        </div>
                        <div className="closeBtn" onClick={handleClose}>
                            <CloseIcon />
                        </div>
                    </div>

                    <div className="windowBody">
                        <div className="formRow">
                            <FormControl className="formInput">
                                <TextField 
                                    type="date" 
                                    label={language !== "eng" ? "日期" : "Date"} 
                                    value={dateShowing} 
                                    disabled={true}
                                    variant="outlined"
                                    
                                />
                            </FormControl>
                        </div>

                        <div className="formRow twoCol">
                            <FormControl className="formInput">
                                <InputLabel>{language !== "eng" ? "課室" : "Classroom"}</InputLabel>
                                <Select
                                    value={newClassRoomInput || ''}
                                    onChange={handleRoomInput}
                                    variant="outlined"
                                >
                                    {classroomList.map((classroom: any) =>
                                        <MenuItem value={classroom.id}>{classroom.classroom}</MenuItem>
                                    )}
                                </Select>
                            </FormControl>

                            <FormControl className="formInput">
                                <InputLabel>{language !== "eng" ? "開始時間" : "Start Time"}</InputLabel>
                                <Select
                                    value={newClassStartingTime || ''}
                                    onChange={handleStringTimeInput}
                                    variant="outlined"
                                    
                                >
                                    {newClassStartingTimeList.map((time: any) =>
                                        <MenuItem value={time}>{time}</MenuItem>
                                    )}
                                </Select>
                            </FormControl>
                        </div>

                        <div className="formRow twoCol">
                            <FormControl className="formInput">
                                <InputLabel>{language !== "eng" ? "佔用時長" : "Duration"}</InputLabel>
                                <Select
                                    value={newClassDuration || ''}
                                    onChange={handleDurationInput}
                                    variant="outlined"
                                    
                                >
                                    {newClassDurationList.map((duration: any) =>
                                        <MenuItem value={duration}>{duration}</MenuItem>
                                    )}
                                </Select>
                            </FormControl>

                            <FormControl className="formInput">
                                <InputLabel>{language !== "eng" ? "種類" : "Sport"}</InputLabel>
                                <Select
                                    value={newClassGenre || ''}
                                    onChange={handleGenreInput}
                                    variant="outlined"
                                    
                                >
                                    {genreTypeLists.map((genre: any) =>
                                        !genre.active ? null :
                                            <MenuItem value={genre.id}>{genre.genre}</MenuItem>
                                    )}
                                </Select>
                            </FormControl>
                        </div>

                        <div className="formRow twoCol">
                            <FormControl className="formInput">
                                <InputLabel>{language !== "eng" ? "年齡組別" : "Age Group"}</InputLabel>
                                <Select
                                    value={newClassAgeGroup || ''}
                                    onChange={handleAgeGroupInput}
                                    variant="outlined"
                                    
                                >
                                    {ageGroupLists.map((ageGroup: any) =>
                                        !ageGroup.active ? null :
                                            <MenuItem value={ageGroup.id}>{ageGroup.age_group}</MenuItem>
                                    )}
                                </Select>
                            </FormControl>

                            <FormControl className="formInput">
                                <InputLabel>{language !== "eng" ? "導師" : "Tutor"}</InputLabel>
                                <Select
                                    value={newClassTutor || ''}
                                    onChange={handleTutorInput}
                                    variant="outlined"
                                    
                                >
                                    {!newClassTutorList ? null :
                                        newClassTutorList.map((tutor: any) =>
                                            <MenuItem value={tutor.tutor_id}>{tutor.name_eng}</MenuItem>
                                        )}
                                </Select>
                            </FormControl>
                        </div>

                        <div className="formRow">
                            <FormControl className="formInput">
                                <TextField 
                                    type="number" 
                                    label={language !== "eng" ? "課堂人數限制（如適用）" : "Class CAP (Optional)"} 
                                    value={newClassCapacity === 0 ? "" : newClassCapacity} 
                                    onChange={handleCapacityInput}
                                    variant="outlined"
                                    
                                />
                            </FormControl>
                        </div>

                        <div className="formRow">
                            <div className="fullyOccupyingToggle">
                                <label className="toggleLabel">{language !== "eng" ? "獨佔課室" : "Fully Occupying"}</label>
                                <div 
                                    className={`toggleSwitch ${newClassFullyOccupying ? 'active' : ''}`}
                                    onClick={handleFullyOccupyingToggle}
                                >
                                    <div className="toggleKnob"></div>
                                </div>
                                <span className="toggleHint">
                                    {newClassFullyOccupying 
                                        ? (language !== "eng" ? '此時段不可有其他課堂' : 'No other classes allowed')
                                        : (language !== "eng" ? '此時段可與其他課堂共享' : 'Can share with other classes')
                                    }
                                </span>
                            </div>
                        </div>

                        <div className="formRow">
                            <div className="fullyOccupyingToggle">
                                <label className="toggleLabel">🔁 {language !== "eng" ? "重複課堂" : "Repeat Class"}</label>
                                <div 
                                    className={`toggleSwitch ${isRepeating ? 'active' : ''}`}
                                    onClick={handleRepeatToggle}
                                >
                                    <div className="toggleKnob"></div>
                                </div>
                                <span className="toggleHint">
                                    {isRepeating 
                                        ? (repeatEndDate 
                                            ? (language !== "eng" ? `重複至 ${repeatEndDate}` : `Repeating until ${repeatEndDate}`)
                                            : (language !== "eng" ? '永久重複' : 'Repeat forever')
                                        )
                                        : (language !== "eng" ? '不重複' : 'No repeat')
                                    }
                                </span>
                            </div>
                        </div>

                        {showRepeatSettings && (
                            <div className="repeatSettingsPanel">
                                <div className="repeatEndDateOptions">
                                    <label className="repeatOptionLabel">
                                        <input 
                                            type="radio" 
                                            name="repeatEndType" 
                                            checked={repeatEndDate !== null}
                                            onChange={() => handleRepeatEndTypeChange('date')}
                                        />
                                        {language !== "eng" ? '重複直到' : 'Repeat until'}
                                    </label>
                                    <input 
                                        type="date" 
                                        className="repeatDateInput"
                                        value={repeatEndDate || ''}
                                        onChange={handleRepeatEndDateChange}
                                        min={dateShowing}
                                    />
                                </div>
                                <div className="repeatEndDateOptions">
                                    <label className="repeatOptionLabel">
                                        <input 
                                            type="radio" 
                                            name="repeatEndType" 
                                            checked={repeatEndDate === null}
                                            onChange={() => handleRepeatEndTypeChange('forever')}
                                        />
                                        {language !== "eng" ? '永久重複' : 'Repeat forever'}
                                    </label>
                                </div>
                            </div>
                        )}
                    </div>

                    <div className="windowFooter">
                        {
                            hasBossAccess(tokenPayload.post) ?
                                <Button 
                                    className="submitBtn" 
                                    variant="contained" 
                                    startIcon={<AddBoxIcon />} 
                                    onClick={handleSubmit}
                                >
                                    {language !== "eng" ? "新增一般課堂" : "Create Group Class"}
                                </Button>
                                :
                                <Button 
                                    className="submitBtn" 
                                    variant="contained" 
                                    startIcon={<AddBoxIcon />} 
                                    onClick={handleSubmit}
                                    disabled
                                >
                                    {language !== "eng" ? "新增一般課堂" : "Create Group Class"}
                                </Button>
                        }
                    </div>
                </div>
            </div>
        );
    }
}

export default AddNewGroupClassWindow;
